import styled from "styled-components";

export const Aside = styled.div`
    width:272px;
    background: #FFFFFF;
    border-radius: 4px;
    display:flex;
    flex-direction: column;
    padding:24px;
    color:#4A4A4A;
    margin-right:32px;



    & .headTitle{
      display:flex;
      align-items: center;
      font-size:16px;
      margin-bottom:10px;
      cursor: pointer;
      font-weight: 900;

    }

    & .reportIcon,.gstIcon{
        margin-right:10px;
    }

    & details[open] .headTitle{
      font-weight:900;
      color:#000;
    }

     & ul{
      display:flex;
      flex-direction: column;
      border-left:solid 1px #DDD;
      padding-left:20px;
      position:relative;
      margin-bottom:20px;
      margin:0 0 20px 7px;
    }

    & ul:before, & ul:after{
      content:'';
      width:5px;
      height:5px;
      background:#DDD;
      border-radius:100%;
      display:flex;
      position: absolute;
      left: -3px;
    }

    & ul:after{
      bottom:0;
    }


    & ul li{
     display:flex;
     font-weight:700;
     font-size:12px;
     line-height:18px;
     padding:8px;
     border-radius:4px;
     cursor: pointer;
    }

    & ul li.active{
      background:#F0F6F9;
      color:#008CFF;
      font-weight:900;
    }
  }
`;